export default {
  // flag: icons.spain,
  language: 'Espanol',
  success: 'Success',
  account: 'Cuenta',
  phoneNumber: 'Número de teléfono',
  password: 'Contraseña',
  confirmPassword: 'Confirmat Contraseña',
  dashboard: 'Tablero',
  welcome: 'Bienvenidos',
  category: 'Categoría',
  subCategory: 'Subcategoría',
  notes: 'Notas',
  entryAllowed: 'Acceso permitido',
  complete: 'Completo',
  notifyTenant: 'Notificar al Residente',
  open: 'Abrir',
  accept: 'Aceptar',
  decline: 'Declinar',
  noPending: 'No tiene órdenes de trabajo asignadas, comuníquese con su gerente para asignar las órdenes de trabajo.',
  order: 'Orden',
  details: 'Detalles',
  materials: 'Materiales',
  pause: 'Pausa',
  presshold: 'Manténgalo presionado para cerrar la sesión.',
  clickscan: 'Haga clic para escanear',
  withdrawreason: 'Motivo de retiro',
  completenotes: 'Notas de finalización de la orden de trabajo',
  youhave: 'Tienes',
  assignments: 'Asignaciones',
  signout: 'Desconectar',
  completethisorder: 'Completa esta orden',
  mysettings: 'Mi configuración',
  languageChanged: 'Idioma actualizado',
  noteSaved: 'Nota guardada',
  myToolbox: 'Mi Caja de Herramientas',
  successAdd: 'sus artículos se han añadido con éxito a su caja de herramientas. Tenga en cuenta que si está dispuesto a devolver cualquier cosa, debe traerlo de vuelta a esta tienda.',
  confirmItems: 'Por favor, confirme que estos son los únicos artículos que está sacando de la tienda',
  thankYou: 'Gracias',
  cancel: 'cancelar',
  confirm: 'Confirmar',
  confirmCheckOut: 'Confirmar compra',
  processedCheckOut: 'Felicitaciones, pago procesado!',
  shopItems: 'Artículos de la Tienda',
  signedOut: 'será cerrado la sesión',
  youHave: 'Tienes',
  itemsIn: 'elementos en su',
  cart: 'carro',
  toolbox: 'caja de instrumento',
  checkOut: 'Compra',
  return: 'Devolver',
  available: 'Disponible',
  name: 'Nombre',
  // RENTALAPPLICATION FORM below

  common_errors: {
    name: 'Por favor ingrese el nombre',
    phone: 'Ingrese el número de teléfono de 10 dígitos',
    empty_email: 'Por favor ingrese el correo electrónico',
    valid_email: 'Por favor, introduzca la dirección de correo electrónico válida'
  },
  landing_page_errors: { email_error: 'Ingrese un correo electrónico válido para continuar!' },
  occupant_errors: {
    leaseholder_dob: 'El arrendatario debe haber terminado',
    no_date: 'Por favor, seleccione la fecha de nacimiento',
    future_date: 'No se puede seleccionar una fecha futura',
    ssn: 'Ingrese el número de seguro social de 9 dígitos',
    phone: 'Por favor, introduzca al menos un número válido'
  },
  movein_errors: {
    movein_date: 'Seleccione una fecha futura',
    floor_plan: 'Please select a floor plan',
    unit_number: 'Please select a unit',
    allowed_date: 'Solo se permite fecha futura o ya seleccionada'
  },
  pet_errors: {
    name: 'Please enter a name',
    breed: 'Please enter a breed',
    weight: 'Please enter a weight',
    type: 'Please enter a type'
  },
  vehicle_errors: {
    model: 'Please enter a model',
    color: 'Please enter a color',
    license: 'Please enter a license number',
    state: 'Please enter a state'
  },
  residency_errors: {
    address: 'Por favor ingrese la dirección',
    state: 'Por favor ingrese el nombre del estado',
    city: 'Por favor ingrese la ciudad',
    zip: 'Por favor ingrese el código postal'
  },
  contacts_errors: { relationship: 'El campo de relación es obligatorio' },
  employment_errors: {
    employment_duration: 'Por favor ingrese la duración del empleo',
    supervisor_name: 'Por favor ingrese el nombre del supervisor',
    monthly_income: 'Por favor ingrese su ingreso mensual',
    extra_income: 'Ingrese su ingreso mensual adicional',
    extra_income_description: 'Ingrese la descripción para ingresos mensuales adicionales'
  },
  document_errors: {
    license: 'Por favor, cargue la licencia de conducir',
    pay_stub: 'Por favor suba el comprobante de pago'
  },
  occupants: 'Ocupantes',
  status: 'Estado',
  full_name: 'Nombre Completo',
  email: 'Email',
  dob: 'Fecha de nacimiento',
  ssn: 'Número de seguridad social',
  home_phone: 'Teléfono de casa',
  work_phone: 'Teléfono del trabajo',
  cell_phone: 'Teléfono móvil',
  drivers_license: 'Licencia de Conducir',
  number: 'Numero',
  state: 'Estado',
  // Move in Info
  mii: 'Mover en la Información',
  emi: 'Movimiento Esperado En',
  unit_number: 'Unidad Numérica',
  // Pets
  add_pet: 'Añadir Mascota',
  pet: 'Mascota',
  type: 'Tipo',
  breed: 'La Variedad',
  weight: 'Peso',
  // Vehicles
  vehicle: 'Vehículo',
  model: 'Haz un modelo',
  color: 'Color',
  license: 'Placa',
  add_vehicle: 'Añadir vehículo',
  // Previous Residences
  prev_residences: 'Residencias Anterior',
  address: 'Dirección',
  duration_residency: 'Duración de la residencia',
  landlord_name: 'Nombre del propietario',
  landlord_num: 'Número de propietario',
  landlord_email: 'Email del propietario',
  // Employment Info
  employment_info: 'Informacion de Empleo',
  employer: 'Empleador',
  occupant: 'Ocupante',
  supervisor_name: 'Nombre del Supervisor',
  employment_duration: 'Duración de Empleo',
  salary: 'Salario Mensual',
  other_income: 'Otros Ingresos',
  description: 'Descripción',
  monthly_income: 'Ingreso Mensual',
  // Emergency Contacts
  add_contact: 'Agregar Contacto',
  contact: 'Contacto',
  relationship: 'Relación',
  // Documents
  add_document: 'Añadir Documento',
  required_document: 'Su talón de pago y licencia de conducir o cualquier otra identificación emitida por un Estado son requeridas como parte del proceso de aplicación.',
  document: 'Documento',
  file: 'Expediente',
  pay_stub: 'Talón de Pago',
  choose_file: 'Elija el Archivo',
  pets_vehicles: 'Mascotas y Vehículos',
  continue_saved: 'Continuar la Aplicación Guardada',
  prev: 'Previo',
  save: 'Guardar',
  next: 'Próximo',
  // labels
  move_in: 'Mover en la Información',
  pets: 'Mascotas',
  vehicles: 'Vehículos',
  histories: 'Residencias Previa',
  employments: 'Informacion de Empleo',
  income: '',
  emergency_contacts: 'Contactos de Emergencia',
  documents: 'Subir Documentos',
  review: 'Revisión',
  // ERRORS
  description_error: 'Introducir descripción',
  // person.js
  name_error: 'Ingrese su Nombre',
  ssn_error: 'SSN inválido (ingrese solo 9 dígitos)',
  email_error: 'Ingrese un email valido',
  phone_error: 'Introduzca al menos un número de teléfono',
  invalid_dob: 'La fecha de nacimiento es inválida',
  too_young: `El arrendatario debe ser mayor de ${window.MINIMUM_AGE || 18} años`,
  // movein.js
  movein_error: 'Introduzca fecha de mudanza',
  // address.js
  invalid_address: 'Dirección inválida',
  address_error: 'Ingresa la direccion',
  city_error: 'Entrar en ciudad',
  state_error: 'Entrar en estado',
  zip_error: 'Ingresa tu código postal',
  // histories.js
  ll_name_error: 'Ingrese el nombre del propietario',
  ll_num_error: 'Ingrese el número de teléfono del propietario',
  rent_error: 'Ingrese el monto del alquiler',
  residency_duration_error: 'Introduzca la duración de la residencia',
  current_error: 'Entrar actual',
  landlord_email_error: 'Ingrese un correo electrónico válido de Lanloard',
  // employment.js
  choose_occupant: 'Elegir Ocupante',
  employment_duration_error: 'Introduzca la duración del empleo',
  employment_name_error: 'Ingrese el nombre del empleador',
  employment_num_error: 'Ingrese el número de teléfono del empleador',
  employment_email_error: 'Ingrese el email del supervisor',
  employment_super_error: 'Ingrese el nombre del supervisor',
  employer_email_error: 'Ingrese un correo electrónico de empleador válido',
  salary_error: 'Introducir salario',
  // pet.js
  pet_name_error: 'Ingrese el nombre de la mascota',
  pet_breed_error: 'Ingrese la raza de mascota',
  pet_type_error: 'Ingrese el tipo de mascota',
  pet_weight_error: 'Introduzca el peso de la mascota',
  // vehicle.js
  vehicle_mm_error: 'Ingresar marca / modelo de vehículo',
  vehicle_color_error: 'Introduce el color del vehículo',
  vehicle_license_error: 'Ingrese el número de placa',
  vehicle_license_state_error: 'Ingrese el estado de la placa',
  // contact.js
  contact_name_error: 'Ingrese el nombre del contacto',
  contact_phone_error: 'Entrar en el teléfono de contacto',
  contact_phone_same_as_occupant: 'Ingrese un número de teléfono que sea único de los solicitantes',
  contact_relation_error: 'Entrar en contacto de relacion',
  // document.js
  document_type_error: 'Ingrese el tipo de documento',
  // Review & Pay & Terms
  submit_app_button: 'Enviar Mi Solicitud',
  submit_fix_errors_button: 'Por Favor Corrija Errores',
  accept_t_and_c_header: 'Por Favor Acepte Los Términos Y Condiciones',
  name_and_agree_input: 'aceptar los términos y condiciones mencionados anteriormente',
  fee_refundability: 'Las tarifas pagadas no son reembolsables.',
  fee_information: 'Pagar la Tarifa de Administración ahora? Aplicaciones completas (las que son presentadas con el pago de la tarifa de aplicación y la tarifa de administración) van a ser procesadas por nuestro personal inmediatamente, resultando en una la fecha más temprana de mudanza para las aplicaciones aceptadas. Todos los otros aplicantes serán procesados en el orden recibido, lo cual puede causar retrasos si alguna información está incompleta.',
  pay_admin_fee_now: '¿Pagar la tarifa administrativa ahora?',
  i: 'Yo',
  yes: 'Si'
};
